module.exports = __webpack_public_path__ + "media/assets/header_bar_arrow-6f2e11e1fc33ef188fae19897fa76ecb788dec4aefa1cb3600c02c809aba995f.png";